import { translateKey } from '@app/shared/utils/static-helpers/translate';
import {
  Prediction,
  PredictionApiBody,
  SubstanceTypeEnum,
  PredictionFromApi,
  RenalDetectRecommendation,
  RenalDetectRecommendationDetails,
  PredictionValues,
} from '@app/core/models';
import { RenalDetectDetectionValues } from '@app/pages/renal-detect/components/renal-detect-detection-form/renal-detect-detection-form';
import { RenalDetectStatusEnum } from '..';

export function buildPredictionApiBody(predictionValues: PredictionValues, lastPrediction?: Prediction): PredictionApiBody {
  return {
    ...predictionValues,
    previousStatus: lastPrediction?.status,
  };
}

export function formatRenalDetectRecommendation(
  data: PredictionFromApi,
  prevStatus: RenalDetectStatusEnum,
  predictionValues: PredictionValues,
): RenalDetectRecommendation {
  return {
    ...getRenalDetectRecoDetailsByStatus(data.status, prevStatus),
    pathologies: data.pathologies || [],
    prediction: {
      status: data.status,
      ...predictionValues,
    },
  };
}

export function getPredictionValuesFromDetection(values: RenalDetectDetectionValues): PredictionValues {
  const { creatinine, urea, ureaSubstance, creatinineUnit, ureaUnit, urine } = values;
  return {
    creatinine: {
      value: creatinine,
      unit: creatinineUnit,
    },
    urine: {
      value: urine,
    },
    urea: {
      value: urea,
      unit: ureaUnit,
      bun: ureaSubstance === SubstanceTypeEnum.BloodUreaNitro,
    },
  };
}

export function getRenalDetectRecoDetailsByStatus(
  status: RenalDetectStatusEnum,
  oldStatus?: RenalDetectStatusEnum,
): RenalDetectRecommendationDetails {
  return {
    [RenalDetectStatusEnum.NotAtRisk]: {
      titleStatusText: translateKey('rd-title-status-not-at-risk'),
      statusText: translateKey('rd_vet_not-at-risk'),
      asterisk: translateKey('rd_vet_not-at-risk_asterisk'),
      recommendation: translateKey('rd_vet_not-at-risk_generic-reco-1'),
      recommendationMeaning: translateKey('rd_vet_not-at-risk_generic-reco-2'),
      nutritionalRecommendation:
        oldStatus === RenalDetectStatusEnum.AtRisk
          ? translateKey('rd_follow-up_vet_no-more-risk')
          : translateKey('rd_vet_not-at-risk_nutritional-reco'),
      recommendationContinuation: '',
      nutritionalMeaning: '',
    },
    [RenalDetectStatusEnum.AtRisk]: {
      titleStatusText: translateKey('rd-title-status-at-risk'),
      statusText: translateKey('rd_vet_at-risk'),
      asterisk: translateKey('rd_vet_at-risk_asterisk'),
      recommendation: translateKey('rd_vet_at-risk_generic-reco-1'),
      recommendationContinuation: translateKey('rd_vet_at-risk_generic-reco-2'),
      recommendationMeaning: translateKey('rd_vet_at-risk_generic-reco-3'),
      nutritionalMeaning: translateKey('rd_vet_at-risk_nutritional-reco-2'),
      nutritionalRecommendation:
        oldStatus === RenalDetectStatusEnum.AtRisk
          ? translateKey('rd_follow-up_vet_still-at-risk')
          : translateKey('rd_vet_at-risk_nutritional-reco-1'),
    },
    [RenalDetectStatusEnum.CKD]: {
      titleStatusText: translateKey('rd-title-status-cdk'),
      statusText: translateKey('rd_vet_ckd'),
      asterisk: translateKey('rd_vet_ckd_asterisk'),
      recommendation: translateKey('rd_vet_ckd_generic-reco-1'),
      nutritionalRecommendation: translateKey('rd_vet_ckd_nutritional-reco-1'),
      nutritionalMeaning: translateKey('rd_vet_ckd_nutritional-reco-2'),
      recommendationContinuation: '',
      recommendationMeaning: '',
    },
  }[status];
}
